<template lang="pug">
div
  template(v-if='showCompanyFields')
    v-layout.flex-column-phone
      text-field(
        label='KvK Nummer',
        v-model='data.kvkNumber',
        :error-messages='kvkNumberValidationErrors',
        @change='$v.data.kvkNumber.$touch()',
        @blur='$v.data.kvkNumber.$touch()',
        name='kvk'
        )

      text-field(
        label='Bedrijfsnaam',
        v-model='data.companyName',
        :error-messages='companyNameValidationErrors',
        @change='$v.data.companyName.$touch()',
        @blur='$v.data.companyName.$touch()',
        name='companyName'
        )

    v-layout.flex-column-phone
      text-field(
        label='Straat',
        v-model='data.streetName',
        :error-messages='streetNameValidationErrors',
        @change='$v.data.streetName.$touch()',
        @blur='$v.data.streetName.$touch()',
        name='street'
        )

      text-field.small(
        label='Huisnummer',
        v-model='data.streetNumber',
        :error-messages='streetNumberValidationErrors',
        @change='$v.data.streetNumber.$touch()',
        @blur='$v.data.streetNumber.$touch()',
        name='streetNumber'
        )

      text-field.small(
        label='Toev.',
        v-model='data.streetNumberAddition',
        name='streetNumberAddition'
        )

    v-layout.flex-column-phone
      text-field(
        label='Postcode',
        v-model='data.postalCode',
        :error-messages='postalCodeValidationErrors',
        @change='$v.data.postalCode.$touch()',
        @blur='$v.data.postalCode.$touch()',
        name='postalCode'
        )

      text-field(
        label='Woonplaats',
        v-model='data.city',
        :error-messages='cityValidationErrors',
        @change='$v.data.city.$touch()',
        @blur='$v.data.city.$touch()',
        name='city'
        )

    label: b Land*
    v-autocomplete(
      :items='countryItems',
      item-value='short_name',
      item-text='name',
      label='Land',
      name='country',
      v-model='data.country',
      required
      :error-messages='countryValidationErrors',
      solo
      )

    v-divider.mb-5.mt-3

  label: b Aanhef*
  v-radio-group(
    v-model='data.contactSex'
    :error-messages='contactSexValidationErrors'
    )
    v-layout
      v-radio.mb-0(value='M', label='De heer', color='primary')
      v-radio.mb-0(value='F', label='Mevrouw', color='primary')

  v-layout.flex-column-phablet
    text-field.small(
      label='Voorletters',
      v-model='data.contactInitials',
      mask='A.A.A.A.A.',
      name='initials',
      required,
      :error-messages='contactInitialsValidationErrors',
      @change='$v.data.contactInitials.$touch()',
      @blur='$v.data.contactInitials.$touch()',
      )

    text-field.small(
      label='Tussenvoegsel',
      v-model='data.contactNameInsertion',
      :error-messages='contactNameInsertionValidationErrors',
      @change='$v.data.contactNameInsertion.$touch()',
      @blur='$v.data.contactNameInsertion.$touch()',
      name='insertion'
      )

    text-field.flex-grow-1(
      label='Achternaam',
      v-model='data.contactLastName',
      name='lastname',
      required,
      :error-messages='contactLastNameValidationErrors',
      @change='$v.data.contactLastName.$touch()',
      @blur='$v.data.contactLastName.$touch()',
      )

  v-layout
    DatePicker(
      label='Geboortedatum'
      v-model='data.contactBirthdate'
      name='birthdate',
      ref='contactBirthdate',
      minimumAge,
      required,
      propName='contactBirthdate',
      @setValid='setValid'
      )

  v-layout.flex-column-phablet
    text-field.flex-grow-1(
      label='Telefoonnummer',
      v-model='data.contactPhone',
      required,
      mask='+## # ## ### ###',
      name='phone',
      :error-messages='contactPhoneValidationErrors',
      @change='$v.data.contactPhone.$touch()',
      @blur='$v.data.contactPhone.$touch()',
      )

    text-field.flex-grow-1(
      label='E-mailadres',
      v-model='data.contactEmail',
      name='email',
      required,
      :error-messages='contactEmailValidationErrors',
      @change='$v.data.contactEmail.$touch()',
      @blur='$v.data.contactEmail.$touch()',
      )
</template>

<script>
// import { required, email, minValue, maxValue } from 'vuelidate/lib/validators'
import required from 'vuelidate/src/validators/required'
import email from 'vuelidate/src/validators/email'
import minLength from 'vuelidate/src/validators/minLength'
import maxLength from 'vuelidate/src/validators/maxLength'
import numeric from 'vuelidate/src/validators/numeric'
import { fullPhoneRegex } from './/helpers/regex'

export default {
  props: {
    value: Object,
    showCompanyFields: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      data: this.value,
      countryItems: require('./assets/countries.json'),

      contactBirthdateValid: false
    }
  },

  methods: {
    setValid ({ propName, valid }) {
      this[propName + 'Valid'] = valid
    }
  },

  computed: {
    kvkNumberValidationErrors () {
      const errors = []
      if (!this.$v.data.kvkNumber.$dirty) return errors
      !this.$v.data.kvkNumber.required && errors.push('Dit veld is verplicht')
      !this.$v.data.kvkNumber.numeric && errors.push('Dit is geen geldig KvK nummer')
      !this.$v.data.kvkNumber.minLength && errors.push('Dit is geen geldig KvK nummer')
      !this.$v.data.kvkNumber.maxLength && errors.push('Dit is geen geldig KvK nummer')
      return errors
    },

    companyNameValidationErrors () {
      const errors = []
      if (!this.$v.data.companyName.$dirty) return errors
      !this.$v.data.companyName.required && errors.push('Dit veld is verplicht')
      return errors
    },

    streetNameValidationErrors () {
      const errors = []
      if (!this.$v.data.streetName.$dirty) return errors
      !this.$v.data.streetName.required && errors.push('Dit veld is verplicht')
      return errors
    },

    streetNumberValidationErrors () {
      const errors = []
      if (!this.$v.data.streetNumber.$dirty) return errors
      !this.$v.data.streetNumber.required && errors.push('Dit veld is verplicht')
      return errors
    },

    cityValidationErrors () {
      const errors = []
      if (!this.$v.data.city.$dirty) return errors
      !this.$v.data.city.required && errors.push('Dit veld is verplicht')
      return errors
    },

    postalCodeValidationErrors () {
      const errors = []
      if (!this.$v.data.postalCode.$dirty) return errors
      !this.$v.data.postalCode.required && errors.push('Dit veld is verplicht')
      return errors
    },

    countryValidationErrors () {
      const errors = []
      if (!this.$v.data.country.$dirty) return errors
      !this.$v.data.country.required && errors.push('Dit veld is verplicht')
      return errors
    },

    contactInitialsValidationErrors () {
      const errors = []
      if (!this.$v.data.contactInitials.$dirty) return errors
      !this.$v.data.contactInitials.required && errors.push('Dit veld is verplicht')
      return errors
    },

    contactSexValidationErrors () {
      const errors = []
      if (!this.$v.data.contactSex.$dirty) return errors
      !this.$v.data.contactSex.required && errors.push('Dit veld is verplicht')
      return errors
    },

    contactNameInsertionValidationErrors () {
      const errors = []
      if (!this.$v.data.contactNameInsertion.$dirty) return errors
      return errors
    },

    contactLastNameValidationErrors () {
      const errors = []
      if (!this.$v.data.contactLastName.$dirty) return errors
      !this.$v.data.contactLastName.required && errors.push('Dit veld is verplicht')
      return errors
    },

    contactEmailValidationErrors () {
      const errors = []
      if (!this.$v.data.contactEmail.$dirty) return errors
      !this.$v.data.contactEmail.required && errors.push('Dit veld is verplicht')
      !this.$v.data.contactEmail.email && errors.push('Dit is geen geldig email adres')
      return errors
    },

    contactPhoneValidationErrors () {
      const errors = []
      if (!this.$v.data.contactPhone.$dirty) return errors
      !this.$v.data.contactPhone.required && errors.push('Dit veld is verplicht')
      !this.$v.data.contactPhone.regex && errors.push('Gebruik het volgende formaat: +31 6 12 123 123')
      return errors
    }
  },

  validations: {
    data: {
      companyName: { // Note: don't need showCompanyFields check here because the fields should be filled in from the KvK tool
        required
      },

      streetName: {
        required
      },

      streetNumber: {
        required
      },

      city: {
        required
      },

      country: {
        required
      },

      postalCode: {
        required
      },

      kvkNumber: {
        required,
        numeric,
        minLength: minLength(8),
        maxLength: maxLength(8)
      },

      contactSex: {
        required
      },

      contactInitials: {
        required
      },

      contactNameInsertion: {},

      contactLastName: {
        required
      },

      contactBirthdate: {
        valid: function (v) {
          return this.contactBirthdateValid
        }
      },

      contactEmail: {
        required,
        email
      },

      contactPhone: {
        required,
        regex: (v) => fullPhoneRegex.test(v)
      }
    }
  },

  watch: {
    '$v.$invalid': {
      handler: function (invalid) {
        if (this.$refs.contactBirthdate) {
          this.$emit('setValid', {
            modelName: 'companyModel',
            valid: !invalid && !this.$refs.contactBirthdate.$v.$invalid
          })
        } else {
          this.$emit('setValid', {
            modelName: 'companyModel',
            valid: !invalid
          })
        }
      },
      deep: true,
      immediate: true
    },

    'value': {
      handler: function (v) {
        this.data = v
      },
      deep: true,
      immediate: true
    },

    data: {
      handler: function (v) {
        this.$emit('input', v)
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
